/**
 * Created by pajicv on 10/26/18.
 */
import { compose } from 'redux';
import { connect } from 'react-redux';
import { firebaseConnect } from 'react-redux-firebase';
import CyclesOverlay from './CyclesOverlay';
import { spinnerWhileLoading } from '../../utils/components';

const enhance = compose(
    connect(
        (state, props) => {
            const { projectId } = props;
            const cycles = state.firebase.data.projects ? state.firebase.data.projects[projectId].cycles : undefined;
            const project = state.firebase.data.projects ? state.firebase.data.projects[projectId] : undefined;
            return {
                cycles,
                project,
                auth: state.firebase.auth
            };
        }
    ),
    firebaseConnect((props) => {
        const { projectId } = props;
        return [{ path: `projects/${projectId}/cycles`, queryParams: [`orderByChild=index`] }, { path: `projects/${projectId}`, queryParams: [`orderByKey`] }];
    }),
    spinnerWhileLoading(['cycles', 'project'])
);

export default enhance(CyclesOverlay);



// WEBPACK FOOTER //
// ./src/components/Overlay/CyclesOverlay.enhancer.js